<template>
  <div :class="['form-group', classe]">
    <label class="small mb-1" :for="id ? id : name">
      {{ label }}
      <span
        v-if="info"
        class="js-show-tooltip"
        data-toggle="tooltip"
        data-placement="top"
        data-html="true"
        :title="info"
      >
          <i class="fas fa-info-circle p-color"></i>
      </span>
    </label>
    <select
        :class="['custom-select', inputClass, { 'is-invalid': erro }]"
        :data-placeholder="placeholder"
        :id="id ? id : name"
        :name="name"
        :required="required"
        :disabled="disabled"
        @change="change"
    >
      <option
        v-if="!value"
        value=""
        disabled
        selected
      >
        {{ placeholder }}
      </option>
      <option
        v-for="(item) in options" :key="item['id']"
        :value="item['id']"
        :data-id="item['id']"
        :selected="value && item['id'] === value.id"
      >
          {{ item['value'] }}
      </option>
    </select>
  </div>

</template>

<script>
export default {
  name: 'Select',
  props: {
    classe: {
      type: String,
      default: '',
    },
    inputClass: {
      type: String,
      default: '',
    },
    erro: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    info: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    value: {},
    placeholder: {
      type: String,
      default: 'Selecione uma opção',
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  methods: {
    change(e) {
      const selectedId = e.target.value;
      const option = this.options.find((opt) => selectedId == opt.id);
      this.$emit('input', option);
    },
  }
};
</script>
 